<div class="label">
  {{ cubeUiName }}
  <ng-container *ngIf="operationName">
    <br />
    <i>{{ operationName }}</i>
  </ng-container>
</div>
